import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { SnackBar } from '@aid/shared/types/classes/snack-bar.class';

@Component({
  selector: 'aid-snack-bar',
  template: `
    <div class="aid-layout-row aid-layout-align-space-between-start">
      <div
        class="full-height full-width aid-layout-row aid-layout-align-start-start aid-layout-gap-16"
      >
        <div
          class="snackbar__icon-container aid-layout-row aid-layout-align-center-center"
          [ngClass]="'snackbar__icon-container--' + data.type"
        >
          <mat-icon
            class="snackbar__icon-container__size"
            [svgIcon]="typeIconMap[data.type]"
          ></mat-icon>
        </div>
        <div
          class="snackbar__icon-container__text aid-layout-column aid-layout-gap-8"
        >
          <div class="mat-subtitle-2">
            {{ data.type | translate | uppercase }}
          </div>
          <div class="mat-subtitle-2">
            {{ data.message | translate: data.translationData }}
          </div>
        </div>
      </div>
      <button
        mat-icon-button
        class="basic-light-color-600 snackbar__icon-container"
        (click)="onClose()"
      >
        <mat-icon class="snackbar__close" svgIcon="close"></mat-icon>
      </button>
    </div>
  `,
  styleUrls: ['./snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SnackBarComponent implements OnInit {
  typeIconMap = {
    success: 'check',
    information: 'information',
    error: 'close'
  };

  constructor(
    private snackBar: MatSnackBar,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: SnackBar
  ) {}

  ngOnInit() {}

  onClose() {
    this.snackBar.dismiss();
  }
}
